import React, { useEffect, useRef, useState, useContext } from "react";
import "bootstrap/dist/css/bootstrap.css";
import Container from "react-bootstrap/Container";
import Figure from "react-bootstrap/Figure";
import "../../style/newsPage/newspage.scss";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import { Button } from "react-bootstrap";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Footer from "../work/footer";
import { UserContext } from "../../use_context";

const API_BASE_URL = "https://infoglans.com/search/wp-json/wp/v2";

function NewsView() {
  // const [acfData, setAcfData] = useState(null);
  const { acfData, setAcfData } = useContext(UserContext);
  // const [imageUrls, setImageUrls] = useState({});
  const { imageUrls, setImageUrls } = useContext(UserContext);

  const [loading, setLoading] = useState(true);
  const scrollRef = useRef(null);

  const [subscribeEmail, setSubscribeEmail] = useState("");
  const [subscribeStatus, setSubscribeStatus] = useState({
    type: null,
    message: "",
  });

  const API_BASE_URL = "https://infoglans.com/search/wp-json/wp/v2";

  const handleScroll = (direction) => {
    const container = scrollRef.current;
    if (container && typeof container.scrollBy === "function") {
      const scrollAmount = 300;
      container.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  const handleSubscribe = async (e) => {
    e.preventDefault();

    if (!subscribeEmail.trim()) {
      setSubscribeStatus({ type: "error", message: "Email is required." });
      return;
    }

    if (!/^\S+@\S+\.\S+$/.test(subscribeEmail)) {
      setSubscribeStatus({ type: "error", message: "Enter a valid email." });
      return;
    }

    const formData = new FormData();
    formData.append("your-email", subscribeEmail);
    formData.append("_wpcf7", "1345");
    // formData.append("_wpcf7_version", "5.7.6");
    // formData.append("_wpcf7_locale", "en_US");
    formData.append("_wpcf7_unit_tag", "wpcf7-f1345-p561-o1");
    // formData.append("_wpcf7_container_post", "561");

    try {
      const response = await fetch(
        "https://infoglans.com/search/wp-json/contact-form-7/v1/contact-forms/1345/feedback",
        {
          method: "POST",
          body: formData,
        }
      );
      const result = await response.json();

      if (result.status === "mail_sent") {
        setSubscribeStatus({
          type: "success",
          message: "Subscription successful!",
        });
        setSubscribeEmail("");
      } else {
        setSubscribeStatus({
          type: "error",
          message: result.message || "Subscription failed.",
        });
      }
    } catch (error) {
      setSubscribeStatus({
        type: "error",
        message: "Server error. Please try again later.",
      });
    }
  };

  useEffect(() => {
    if (acfData && imageUrls) {
      setLoading(false); // <== This fixes the loader hang issue
      return;
    }
    const fetchMediaUrl = async (id) => {
      if (!id) return null;
      try {
        const res = await fetch(`${API_BASE_URL}/media/${id}`);
        const json = await res.json();
        return json.source_url || null;
      } catch (err) {
        console.error(`Failed to fetch media ${id}:`, err);
        return null;
      }
    };

    const fetchData = async () => {
      try {
        const pageRes = await fetch(`${API_BASE_URL}/pages/561`);
        const pageJson = await pageRes.json();

        const acf = pageJson.acf || {};
        const publicationsArray =
          acf.publications || acf.publications_copy || [];

        const imageIds = [];
        const extractIds = (arr, key) =>
          Array.isArray(arr) &&
          arr.forEach((item) => item[key] && imageIds.push(item[key]));

        extractIds(acf.section_1, "section_1_img");
        extractIds(acf.section_2, "section_2_img");
        extractIds(acf.section_3, "section_3_img");
        acf.news_video && imageIds.push(acf.news_video);

        publicationsArray.forEach((pub) => {
          pub.publications_img && imageIds.push(pub.publications_img);
          pub.publications_pdf && imageIds.push(pub.publications_pdf);
        });

        const mediaFetches = imageIds.map((id) =>
          fetch(`${API_BASE_URL}/media/${id}`).then((r) => r.json())
        );
        const mediaData = await Promise.all(mediaFetches);

        const urls = {};
        mediaData.forEach((m) => {
          if (m.id && m.source_url) urls[m.id] = m.source_url;
        });

        const updatedPublications = await Promise.all(
          publicationsArray.map(async (pub) => {
            const imgUrl = pub.publications_img
              ? await fetchMediaUrl(pub.publications_img)
              : null;
            const pdfUrl = pub.publications_pdf
              ? await fetchMediaUrl(pub.publications_pdf)
              : null;

            return {
              ...pub,
              publications_img_url: imgUrl,
              publications_pdf: pdfUrl,
            };
          })
        );

        setAcfData({
          ...acf,
          publications: updatedPublications,
        });
        setImageUrls(urls);
      } catch (err) {
        console.error("Failed to fetch or process data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <div className="loader-mask">
        <div className="loader"></div>
      </div>
    );
  }
  return (
    <div>
      <Container fluid className="news-view-div">
        <Row className="gx-0 mt-5">
          <Col lg={9} id="home">
            <p className="news-latest-press-release-videos">
              Latest Press Release
            </p>

            {/* Section 1 */}
            {acfData?.section_1?.map((item, index) => (
              <Figure className="news-figure" key={index}>
                <Figure.Image
                  className="news-figure-img"
                  alt="Main News"
                  src={imageUrls[item.section_1_img]}
                />
                <Figure.Caption className="news-figure-caption">
                  {item.section_1_text}
                  <br />
                  <br />
                  <h6>{item.section_1_date}</h6>
                </Figure.Caption>
              </Figure>
            ))}

            {/* Section 2 */}
            <Row>
              {acfData?.section_2?.map((item, index) => (
                <Col className="news-col-center p-0" lg={6} md={12} key={index}>
                  <Figure className="news-figures-container">
                    <Figure.Image
                      className="news-figure-img2 news-img-section-2"
                      alt="News"
                      src={imageUrls[item.section_2_img]}
                    />
                    <Figure.Caption className="news-fig-f-z">
                      {item.section_2_text}
                      <br />
                      <h6 className="pt-5">{item.section_2_date}</h6>
                    </Figure.Caption>
                  </Figure>
                </Col>
              ))}
            </Row>

            <hr className="news-hr-line" />
          </Col>

          {/* Sidebar */}
          <Col lg={3} className="news-sidebar-div">
            <p className="news-subscribe-to-news-letters">
              Subscribe to Newsletter
            </p>
            <form onSubmit={handleSubscribe}>
              <InputGroup className="subscribe-input-group">
                <Form.Control
                  placeholder="Enter your email"
                  aria-label="Subscribe"
                  aria-describedby="basic-addon2"
                  value={subscribeEmail}
                  onChange={(e) => setSubscribeEmail(e.target.value)}
                />
                <Button
                  id="basic-addon2"
                  className="subscribe-button"
                  onClick={handleSubscribe}
                >
                  Subscribe
                </Button>
              </InputGroup>

              {subscribeStatus.message && (
                <p
                  className={
                    subscribeStatus.type === "error"
                      ? "text-danger"
                      : "text-success"
                  }
                >
                  {subscribeStatus.message}
                </p>
              )}
            </form>

            <div className="mt-4">
              <p className="news-sidebar-updates">Updates</p>
              {acfData?.section_3?.map((item, idx) => (
                <Figure className="news-figure3" key={idx}>
                  <Figure.Image
                    className="news-figure-img3"
                    alt="News Update"
                    src={imageUrls[item.section_3_img]}
                  />
                  <Figure.Caption className="news-figure-caption3">
                    {item.section_3_text}
                    <br />
                    <br />
                    <h6>{item.section_3_date}</h6>
                  </Figure.Caption>
                </Figure>
              ))}
            </div>
          </Col>
        </Row>

        {/* Section 3 Video */}
        {acfData?.news_video && (
          <div className="news-video-div" id="video">
            <p className="news-latest-press-release-videos">Videos</p>
            {acfData?.news_video && imageUrls?.[acfData.news_video] && (
              <video
                style={{
                  maxHeight: "700px",
                  width: "100%",
                }}
                className="news-video"
                controls
                src={imageUrls[acfData.news_video]}
              />
            )}
          </div>
        )}
        <h3
          id="Publications"
          className="mt-5 mb-5 text-center"
          style={{ fontSize: "35px" }}
        >
          Publications
        </h3>

        <div style={{ padding: "20px" }}>
          <Row className="align-items-center position-relative">
            <Col md={12}>
              <div
                ref={scrollRef}
                className="d-flex overflow-auto custom-scrollbar"
                style={{
                  gap: "5rem",
                  whiteSpace: "nowrap",
                  scrollBehavior: "smooth",
                  overflowX: "auto",
                }}
              >
                {/* Add this style block */}
                <style>
                  {`
                    .publication-img {
                      height: 430px;
                      width: auto;
                      object-fit: cover;
                      display: block;
                      margin: 0 auto;
                    }
                  `}
                </style>

                {/* Your publications mapping */}
                {acfData?.publications?.map((pub, index) => (
                  <div
                    key={index}
                    className="mb-4"
                    style={{ minWidth: "300px", flex: "0 0 auto" }}
                  >
                    {pub.publications_img_url && pub.publications_pdf ? (
                      <a
                        href={pub.publications_pdf}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src={pub.publications_img_url}
                          alt="Publication"
                          className="img-fluid mb-2 publication-img"
                        />
                      </a>
                    ) : (
                      pub.publications_img_url && (
                        <img
                          src={pub.publications_img_url}
                          alt="Publication"
                          className="img-fluid mb-2 publication-img"
                        />
                      )
                    )}
                    <h5 className="office-leadership-semibold">
                      {pub.publications_title || "No title"}
                    </h5>
                    <p>{pub.publications_desc || "No description available"}</p>
                  </div>
                ))}
              </div>
            </Col>
          </Row>
        </div>

        <Footer />
      </Container>
    </div>
  );
}

export default NewsView;
